import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { LanguageServices } from './LanguageServices';

export interface SnackMessage{
    message:string;
    tipo: string;
    action?:string;
}

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private _snackBar:MatSnackBar, private ts:LanguageServices) { }

  messages:SnackMessage[] = [];
  private isInstanceVisible = false;
  private snackBarRef:  MatSnackBarRef<TextOnlySnackBar>;
  sub:Subscription;

  addMessage(snackMessage:SnackMessage){

    this.messages.push(snackMessage);
      if (!this.isInstanceVisible) {
          this.showNext(); 
      }
  }

  showNext() {
    if (this.messages.length === 0) {
      return;
    }
    
    let message = this.messages.shift();
    this.isInstanceVisible = true;
    if ( message.tipo =='sucesso'){
        this.snackBarRef = this.showSuccessButton(this.ts.instant(message.message), message.action,1500);
    }else{
        this.snackBarRef = this.showErrorButton(this.ts.instant(message.message), message.action);
    }
    
    this.sub = this.snackBarRef.afterDismissed().subscribe(() => {
      this.isInstanceVisible = false;
      this.showNext();
    });
  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }

  showError( message:string){
    this._snackBar.open(((String)(this.ts.instant(message))), '', {
      duration: 4000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass:"notif-error"
    })
  }

  showErrorButton( message:string, action:string){
    return this._snackBar.open(((String)(this.ts.instant(message))), action, {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass:"notif-error"
    })
  }

  showSuccess ( message:string ){
    this._snackBar.open(((String)(this.ts.instant(message))), '', {

      duration: 4000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass:"notif-success"
    });
  }

  showSuccessButton ( message:string,action:string, timer?:number ){

    if ( timer != null){
      
        return this._snackBar.open(((String)(this.ts.instant(message))), action, {
          duration: timer,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass:"notif-success"
        });
    }else{
        return this._snackBar.open(((String)(this.ts.instant(message))), action, {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass:"notif-success"
        });
    }
    
  }

  showInformation( message:string){
    this._snackBar.open(((String)(this.ts.instant(message))), '', {
      duration: 4000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass:"notif-information"
    })
  }
}
